// src/features/treasury/components/TreasuryDashboard/TreasuryModals.jsx
import React, { useState, useEffect } from 'react';
import Modal, { ModalFooter } from '../../../../shared/components/ui/Modal';
import { depositFunds, withdrawFunds, adjustBalance } from '../../../../api';
import styles from './TreasuryDashboard.module.css';

const TreasuryModals = ({ activeModal, onClose, onSuccess }) => {
    const [formData, setFormData] = useState({ amount: '', description: '', notes: '', opening_balance: '' });
    const [submitting, setSubmitting] = useState(false);
    const[error, setError] = useState('');

    useEffect(() => {
        if (activeModal) {
            setFormData({ amount: '', description: '', notes: '', opening_balance: '' });
            setError('');
        }
    }, [activeModal]);

    const handleChange = (e) => setFormData(p => ({ ...p, [e.target.name]: e.target.value }));

    const handleSubmit = async () => {
        setSubmitting(true);
        setError('');
        try {
            if (activeModal === 'deposit') {
                await depositFunds({ amount: formData.amount, description: formData.description, notes: formData.notes });
            } else if (activeModal === 'withdraw') {
                await withdrawFunds({ amount: formData.amount, description: formData.description, notes: formData.notes });
            } else if (activeModal === 'adjust') {
                await adjustBalance({ opening_balance: formData.opening_balance });
            }
            onSuccess();
        } catch (err) {
            setError(err.response?.data?.error || 'حدث خطأ أثناء تنفيذ العملية.');
        } finally {
            setSubmitting(false);
        }
    };

    if (!activeModal) return null;

    const titles = { deposit: 'إيداع نقدي في الخزينة', withdraw: 'سحب نقدي من الخزينة', adjust: 'تعديل الرصيد الافتتاحي' };

    return (
        <Modal isOpen={!!activeModal} onClose={onClose} title={titles[activeModal]} footer={<ModalFooter onClose={onClose} onSave={handleSubmit} loading={submitting} />}>
            <div className={styles.formContent}>
                {error && <div className={styles.errorMsg}>{error}</div>}
                
                {(activeModal === 'deposit' || activeModal === 'withdraw') && (
                    <>
                        <div className={styles.formGroup}>
                            <label>المبلغ (د.ع) *</label>
                            <input type="number" step="any" name="amount" value={formData.amount} onChange={handleChange} required autoFocus/>
                        </div>
                        <div className={styles.formGroup}>
                            <label>الوصف / البيان *</label>
                            <input type="text" name="description" value={formData.description} onChange={handleChange} required placeholder="مثال: تمويل، سحب للمالك..." />
                        </div>
                        <div className={styles.formGroup}>
                            <label>ملاحظات إضافية (اختياري)</label>
                            <textarea name="notes" value={formData.notes} onChange={handleChange} rows={2} />
                        </div>
                    </>
                )}

                {activeModal === 'adjust' && (
                    <div className={styles.formGroup}>
                        <label>الرصيد الافتتاحي الجديد (د.ع) *</label>
                        <input type="number" step="any" name="opening_balance" value={formData.opening_balance} onChange={handleChange} required autoFocus/>
                        <small style={{color: 'var(--text-muted)', marginTop: '5px'}}>سيتم حساب الفرق وتعديل الرصيد الحالي تلقائياً بناءً على القيمة الجديدة.</small>
                    </div>
                )}
            </div>
        </Modal>
    );
};
export default TreasuryModals;